import PasswordShowHide from "./PasswordShowHide";
import { Form } from "react-bootstrap";

const FormPasswordRegisterOrUpdate = ({
  controlFormId,
  passwordShow,
  pwd,
  setPwd,
  pwdConfirm,
  setPwdConfirm,
  handlePasswordShow,
  errorPassword,
  handleInputChange,
}) => {
  return (
    <>
      <Form.Group className="mb-3" controlId={`new-password-${controlFormId}`}>
        <Form.Label>{controlFormId === "update-password-header" ? "Nouveau mot" : "Mot"} de passe</Form.Label>
        <Form.Group className="row">
          <div className="col-md-10 pe-0">
            <Form.Control
              type={passwordShow ? "text" : "password"}
              placeholder="Password"
              required
              name="pwd"
              autoComplete="new-password"
              className="passwordHide"
              title="Le mot de passe doit contenir au moins 8 caractères, un lettre majuscule, un une lettre miniscule, 
            un chiffre, un caractère spécial(#?!@$%^&*-)."
              pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$"
              value={pwd}
              onChange={(e) => {
                handleInputChange(e);
                setPwd(e.target.value);
              }}
            />
          </div>
          <PasswordShowHide
            handlePasswordShow={handlePasswordShow}
            passwordShow={passwordShow}
          />
        </Form.Group>
      </Form.Group>
      <Form.Group
        className="mb-3"
        controlId={`new-passwordConfirm-${controlFormId}`}
      >
        <Form.Label>Confirmation {controlFormId === "update-password-header" ? "nouveau" : ""} mot de passe</Form.Label>
        <Form.Group className="row">
          <div className="col-md-10 pe-0">
            <Form.Control
              type={passwordShow ? "text" : "password"}
              placeholder="Password"
              required
              name="pwdConfirm"
              autoComplete="new-passwordConfirm"
              className="passwordHide"
              title="Le mot de passe doit contenir au moins 8 caractères, un lettre majuscule, un une lettre miniscule, 
            un chiffre, un caractère spécial(#?!@$%^&*-)."
              pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$"
              value={pwdConfirm}
              onChange={(e) => {
                handleInputChange(e);
                setPwdConfirm(e.target.value);
              }}
            />
          </div>
          <PasswordShowHide
            handlePasswordShow={handlePasswordShow}
            passwordShow={passwordShow}
          />
        </Form.Group>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Text className="text-danger">{errorPassword}</Form.Text>
      </Form.Group>
    </>
  );
};

export default FormPasswordRegisterOrUpdate;
